import React, { useEffect, useState } from "react";
import Icon from "../../../components/AppIcon";
import Button from "../../../components/ui/Button";
import Input from "../../../components/ui/Input";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { checkOrderService } from "redux/services/general_service";
import { toast } from "react-toastify";

const OrderSummary = ({
  cartItems,
  onApplyPromoCode,
  onProceedToCheckout,
  currentStep,
  isLoading = false,
  //  isAuthenticated, // Add isAuthenticated prop
}) => {
  const { t } = useTranslation();

  const dispatch = useDispatch();

  const isAuthenticated = localStorage.getItem("isAuthenticated");

  const [promoCode, setPromoCode] = useState("");
  const [promoError, setPromoError] = useState("");
  const [promoSuccess, setPromoSuccess] = useState("");
  const [isApplyingPromo, setIsApplyingPromo] = useState(false);

  // Calculate subtotal, shipping, and total
  const subtotal = cartItems.reduce((acc, item) => {
    const itemPrice = isAuthenticated
      ? item.product.has_discount
        ? item.product.price_after_discount
        : item.product.price
      : item.has_discount
      ? item.price_after_discount
      : item.price;

    return acc + itemPrice * item.quantity;
  }, 0);

  const shipping = 0; // Assuming free shipping for simplicity
  const total = subtotal + shipping; // Add shipping to subtotal for total

  const [totalPrice, setTotalPrice] = useState(total);
  const [discountDivision, setDiscountDivision] = useState(0);
  const handleApplyPromo = async () => {
    if (!promoCode.trim()) {
      setPromoError(t("promoCodeRequired"));
      return;
    }

    setIsApplyingPromo(true);
    setPromoError("");
    setPromoSuccess("");

    // Simulate API call
    setTimeout(() => {
      // Mock promo code validation

      /*  if (validCodes.includes(promoCode.toUpperCase())) {
        setPromoSuccess(t("promoCodeApplied", { code: promoCode }));*/

      // Prepare cart_ids array
      const cart_ids = cartItems.map((item) => item.cart_id);
      const formData = new FormData();
      cart_ids?.map((cart, index) =>
        formData.append(`cart_ids[${index}]`, cart)
      );

      formData.append("discount_coupon_code", promoCode);
      formData.append("province_id", 1);

      dispatch(checkOrderService(formData)).then((response) => {
        if (response?.payload?.status == 200) {
          console.log(response?.payload);
          //onApplyPromoCode(promoCode);
          setPromoSuccess(t("promoCodeApplied", { code: promoCode }));
          setTotalPrice(total - response?.payload?.data?.data?.discount_value);
          setDiscountDivision(response?.payload?.data?.data?.discount_value);
          localStorage.setItem("discount_coupon_code", promoCode);
        } else {
          console.log(response?.payload);
          setPromoError(t("invalidPromoCode"));
          Object.entries(response.payload.errors).forEach(
            ([key, errorArray]) => {
              // لكل مفتاح، نمر على مصفوفة الأخطاء
              errorArray.forEach((error) => {
                // نعرض كل خطأ باستخدام toast
                toast.warn(` ${error}`);
              });
            }
          );
        }
      });
      setIsApplyingPromo(false);

      /*  } else {
        setPromoError(t("invalidPromoCode"));
      }*/

      //   setIsApplyingPromo(false);
    }, 1000);
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleApplyPromo();
    }
  };
  useEffect(() => {
    //setOrderData({shipping_price:shipping,products_price:total,})
  }, []);

  return (
    <div className="bg-card border border-border rounded-[16px] p-4 sm:p-6 sticky top-20">
      <h2 className="text-xl font-semibold text-foreground mb-6 text-right">
        {t("orderSummary")}
      </h2>

      {/* Promo Code Section */}
      <div className="mb-6">
        <div className="flex gap-2">
          <div className="flex-1">
            <Input
              type="text"
              placeholder={t("enterPromoCode")}
              value={promoCode}
              onChange={(e) => setPromoCode(e.target.value)}
              onKeyPress={handleKeyPress}
              error={promoError}
              className="mb-0"
            />
          </div>
          <Button
            variant="outline"
            onClick={handleApplyPromo}
            loading={isApplyingPromo}
            disabled={!promoCode.trim()}
          >
            {t("apply")}
          </Button>
        </div>

        {promoSuccess && (
          <div className="flex items-center gap-2 mt-2 text-sm text-success">
            <Icon name="CheckCircle" size={16} />
            {promoSuccess}
          </div>
        )}
      </div>

      {isLoading ? (
        <div>
          <Skeleton count={3} height={20} />
          <Skeleton count={1} height={40} className="mt-4" />
        </div>
      ) : (
        <>
          <div className="space-y-3 mb-6">
            <div className="flex justify-between text-foreground">
              <span>{t("subtotal")}</span>
              <span>
                {subtotal} {t("IQD")}
              </span>
            </div>

            <div className="flex justify-between text-foreground">
              <span>{t("shipping")}</span>
              <span>
                {shipping === 0 ? t("free") : `${shipping} ${t("IQD")}`}
              </span>
            </div>

            <div className="border-t border-border pt-3">
              <div className="flex justify-between text-lg font-bold text-foreground">
                <span>{t("total")}</span>
                <span>
                  {totalPrice} {t("IQD")}
                </span>
              </div>
            </div>

            {/* حقل قسمة الحسم */}
            {promoSuccess && (
              <div className="flex justify-between text-foreground font-bold">
                <span>{t("discountDivision")}</span>
                <span>
                  {discountDivision} {t("IQD")}
                </span>
              </div>
            )}
          </div>

          {/* Checkout Button */}
          {/*currentStep !== 3 && (
            <Button
              variant="default"
              size="lg"
              fullWidth
              onClick={onProceedToCheckout}
              loading={isLoading}
              className="mb-4"
            >
              {t("proceedToCheckout")}
            </Button>
          )*/}

          {/* Continue Shopping */}
         
            <Button
              variant="ghost"
              size="sm"
              fullWidth
              onClick={() => window.history.back()}
            >
              {t("continueShopping")}
            </Button>
          
        </>
      )}
    </div>
  );
};

export default OrderSummary;
